/**
 * ErrorDashboardPage Route Component
 *
 * Page component integrating ErrorDashboard
 */

import React from "react";
import ErrorDashboard from "../components/analyzers/ErrorDashboard/ErrorDashboard";

const ErrorDashboardPage = () => {
  return <ErrorDashboard />;
};

export default ErrorDashboardPage;
